import { FC, PropsWithChildren } from 'react';

import styles from './head.module.scss';

interface Props extends Required<PropsWithChildren> {
  className?: string;
}

export const TableHead: FC<Props> = ({ children, className = '' }) => {
  return <div className={`${styles.head} ${className}`}>{children}</div>;
};
